import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StatusBadgeComponent } from './status-badge.component';
import { StatusColorDirective } from './status-color.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [StatusBadgeComponent, StatusColorDirective],
  exports: [StatusBadgeComponent, StatusColorDirective]
})
export class StatusModule {}
